module.exports = __webpack_public_path__ + "static/img/vod-bn-13.fc91f9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vod-bn-13.jpg
// module id = mQPO
// module chunks = 1